export const datosTeatro = {
  nombre: 'Espacio Cultural Teatro H. Bosch',
  descripcion: 'Sala de Teatro y Centro Educativo de Artes Integrales',
  direccion: 'Av. Gonzalo Ramírez 1824',
  cpCiudad: 'Montevideo - Uruguay - CP 11200',
  celular: '092 228 646',
  email: 'info@teatrohbosch.uy',
  instagram: 'https://www.instagram.com/espaciobosch/',
  facebook: 'https://www.facebook.com/Centro.Cultural.Bosch/',
  emailDev: 'teatrobosch.dev@gmail.com',
  whatsapp: {
    numeroWaMe: '59892228646',
    mensajeAutomatico: '¡Hola! Estoy contactándolos desde el sitio web.',
  },
};
